

































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import UpdateAccountLendingInterestSettingsRequest from '@/models/Accounts/LendingAccounts/Ledgers/Settings/LendingInterest/UpdateAccountLendingInterestSettingsRequest';
import ListUtils from '@/lib/listUtils';
import InterestRateType from '@/models/Products/InterestRateType';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'AccountLendingInterestSettingsEditDialog' })
export default class extends SaascadaVueDialog {

    InterestRateType = InterestRateType;
    request: UpdateAccountLendingInterestSettingsRequest = new UpdateAccountLendingInterestSettingsRequest(LendingAccountModule.lendingAccount.accountSettings.lendingInterestSettings, new Date());
    dialog = false;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            // In simulation mode, initialise the request with the simulation version of the settings
            // Otherwise use the original settings from the account
            if (LendingAccountModule.simulationModeEnabled) {
                this.request = new UpdateAccountLendingInterestSettingsRequest(LendingAccountModule.simulation.lendingSettings.lendingInterestSettings, new Date());
            }
            else {
                this.request = new UpdateAccountLendingInterestSettingsRequest(LendingAccountModule.lendingAccount.accountSettings.lendingInterestSettings, new Date());
            }
            await ProductDetailsModule.getRateSources();
        }
    }

    get settings() {
        return LendingAccountModule.lendingAccount.accountSettings.lendingInterestSettings;
    }

    get interestRateTypeOptions() {
        return ListUtils.interestRateTypeOptions();
    }

    get rateSourceOptions() {
        return ProductDetailsModule.rateSources;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
           return;
        }
        else {
            this.dialog = false;
            this.request.rateValue = +this.request.rateValue;
            await LendingAccountModule.editLendingInterestSettings(this.request);
        }
    }

}
